/**
 * Navigate the current tab to an absolute (often cross-origin) URL.
 *
 * Wrapped in a helper so callers can express intent and tests can stub navigation —
 * `window.location` is non-configurable in jsdom, so assigning it directly is hard to mock.
 */
export function navigateTo(url: string): void {
  window.location.href = url
}
